import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/** Renders the "you won a giveaway" alert in the notifications dropdown. */
export default class GiveawayWonNotification extends Notification {
  icon() {
    return 'fas fa-gift';
  }
  href() {
    const data = this.attrs.notification.content() || {};
    return data.slug ? app.route('giveaways.show', {
      slug: data.slug
    }) : app.route('giveaways.index');
  }
  content() {
    return app.translator.trans('ernestdefoe-giveaways.forum.notification.won_content');
  }
  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data.prize || data.title;
  }
}
flarum.reg.add('ernestdefoe-giveaways', 'forum/components/GiveawayWonNotification', GiveawayWonNotification);